<template>
    <el-dialog :close-on-click-modal="false" title="报告列表" center :visible.sync="visible" width="976px">
        <div class="info" style="margin-top: 10px;" v-loading="listLoading">
            <el-table class="content_table" :data="tableData" style="width: 100%;margin:  0 auto;">
                <el-table-column :label="item.label" :prop="item.post" align="center" v-for="(item, index) of tHeader" :key="index" :width="item.width">
                    <template slot-scope="scope">
                        <span class="ellipsis" :title="scope.row[item.post]">
                            {{ scope.row[item.post] || '/' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" header-align="center" align="center" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button style="padding: 0;" type="text" @click="seeOne(scope.row)">查看报告</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="mod-page" v-if="goodsId">
                <pagination v-show="totalPage > 0" :total="totalPage" :page.sync="current" :limit.sync="pageSize" @pagination="getListByPage" />
            </div>
        </div>
        <result v-if="resVisible" ref="result"></result>
    </el-dialog>
</template>
<script>
import Result from "./result.vue";
import Pagination from "@/components/Pagination";
export default {
    components: {
        Result,
        Pagination
    },
    data() {
        return {
            visible: false,
            resVisible: false,
            tableData: [],
            tHeader: [
                {
                    label: "报告编号",
                    post: "reportNo",
                    type: "input",
                    width:240
                },
                {
                    label: "生成时间",
                    post: "addTime",
                    type: "date"
                },
                {
                    label: "单位名称",
                    post: "orgWtName",
                    type: "input"
                },
                {
                    label: "样品名称",
                    post: "sampleName",
                    type: "input"
                },
                {
                    label: "样品型号",
                    post: "specModel",
                    type: "input"
                },
                {
                    label: "检测结果",
                    post: "determination",
                    type: "select",
                    spost: "isQualified",//下拉框传参
                    options: [
                        {
                            label: "合格",
                            code: true
                        },
                        {
                            label: "不合格",
                            code: false
                        },
                        {
                            label: "不做判定",
                            code: 'other'
                        }
                    ]
                }
            ],
            securityCode: '',
            goodsId: '',
            current: 1,
            pageSize: 10,
            totalPage: 0,
            listLoading: false
        }
    },
    methods: {
        init(data, type, from) {
            this.visible = true;
            if (from == 'order') {
                //来自订单列表的报告，有分页
                this.goodsId = data;
                this.current = 1;
                this.getListByPage();
                return
            }
            this.goodsId = '';
            this.tableData = data;
            this.securityCode = type;
        },
        getListByPage() {
            this.listLoading = true;
            this.$http.post(this.$api.orderApi.getReport, {
                current: this.current,
                size: this.pageSize,
                data: {
                    goodsId: this.goodsId
                }
            }).then(({ data }) => {
                this.listLoading = false;
                // if (!data.data || !data.data.list.length) {
                //     this.resVisible = true;
                //     this.$nextTick(() => {
                //         this.$refs.result.init(data, '');
                //     });
                //     return
                // }
                this.totalPage = data.data.total || 0;
                this.tableData = data.data.list || [];
            }).catch(() => {
                this.listLoading = false;
                this.totalPage = 0;
                this.tableData = [];
            });
        },
        seeOne(row) {
            if (this.goodsId) {
                if (!row.repPreUri) {
                    this.$message.info("报告正在生成中")
                    return
                }
                window.open(window.SITE_CONFIG["baseUrl"] + '/checkmall-file/api/file/previewFile?fileCode=' + row.repPreUri);
                return
            }
            this.resVisible = true;
            this.$nextTick(() => {
                this.$refs.result.init({ data: row }, this.securityCode);
            });
        }
    }
}
</script>